import { mapValues } from "lodash-es";

import type { Team } from "@/model/session";
import type { AuthUser, UserOrgEntities } from "@/model/user";
import { colorFromNumber } from "@/utils/color";
import { hash } from "@/utils/string";

import type { ServerAuthUser, ServerUserOrgEntities, ServerUserTeam } from "../serverModel";

export function mapUserTeams(teams: ServerUserTeam[]): Team[] {
  return teams.map((team) => ({
    id: "" + team.id,
    name: team.name,
    artId: team.art_id ? "" + team.art_id : undefined,
  }));
}

export function mapUser(user: ServerAuthUser): AuthUser {
  const name = mapUserName(user);
  return {
    type: "regular",
    id: user.id,
    name,
    email: user.email,
    imageUrl: user.image_url,
    color: user.color || colorFromNumber(hash(name)),
    preferredLanguage: user.preferred_language,
    hash: user.hash,
  };
}

export function mapUserName(user: { name?: string; email?: string }) {
  return user.name || user.email?.substring(0, user.email.indexOf("@")) || "";
}

export function mapOrgEntities(entities: ServerUserOrgEntities): UserOrgEntities {
  return mapValues(entities, (items) => items.map((item) => ({ ...item, id: item.id.toString() })));
}
